import React, { useEffect, useState } from 'react'
import loginLottie from '../../resources/loginLottie.json'
import Lottie from 'react-lottie';
import { zivaIcon_Image } from '../../constants/imageConstants';
import { Input } from '../../components/UsedInputs';
import { InlineError } from '../../components/Notifications/Error';
import { yupResolver } from '@hookform/resolvers/yup';
import { useForm } from 'react-hook-form';
import { LoginFormValidation } from '../../components/Validations/LoginFormValidation';
import { motion } from "framer-motion";
import Loader from '../../components/Notifications/Loader';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { toast } from "react-toastify";
import { loginAction } from '../../redux/actions/userAction';

const Login = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const { isLoading, isError, userInfo, isSuccess } = useSelector(
        (state) => state.userLogin
    );

    const defaultOptions = {
        loop: true,
        autoplay: true,
        animationData: loginLottie,
        renderer: 'svg'
    }

    const {
        register,
        handleSubmit,
        reset,
        control,
        formState: { errors },
    } = useForm({
        resolver: yupResolver(LoginFormValidation),
    });

    // on submit
    const onSubmit = async (data) => {
        dispatch(loginAction(data));

    };

    const onErrors = (errors) => console.log(errors);

    // useEffect
    useEffect(() => {
        console.log(isSuccess, userInfo)
        if (isSuccess && userInfo?.email !== undefined) {
            navigate("/dashboard");
            toast.success(`Welcome back ${userInfo?.email}`);
        }
        if (isError) {
            toast.error(isError);
            dispatch({ type: "USER_LOGIN_RESET" });
        }
    }, [userInfo, isSuccess, isError, navigate, dispatch]);

    return (
        <div className='grid grid-cols-12 grid-cols'>
            <div className='sm:col-span-6 col-span-12 sm:h-screen h-[50vh]'>
                <Lottie
                    options={defaultOptions}
                    width={"100%"}
                    style={{
                        background: '#B69586'
                    }}
                />
            </div>
            <div className='bg-white sm:col-span-6 col-span-12 flex flex-col justify-center items-center sm:mt-0 pt-4' >
                <img
                    src={zivaIcon_Image}
                    className='w-16 h-16 object-contain'
                    alt=""
                />
                <h1 className='text-4xl'><b>Admin</b> Login</h1>
                <form onSubmit={handleSubmit(onSubmit, onErrors)}>
                    <div className='sm:w-[50vw] sm:px-14  w-[100vw] px-12'>
                        <Input
                            label=""
                            placeholder="Your Email"
                            type="email"
                            bg={true}
                            name="email"
                            register={register}
                            error={errors.email}
                        />
                        {errors.email && <InlineError text={errors.email.message} />}
                    </div>
                    <div className='sm:w-[50vw] sm:px-14 w-[100vw] px-12'>
                        <Input
                            label=""
                            placeholder="Your Password"
                            type="password"
                            bg={true}
                            name="password"
                            register={register}
                            error={errors.password}
                        />
                        {errors.password && <InlineError text={errors.password.message} />}
                    </div>
                    <div
                        className="flex flex-col  sm:mx-14 mx-12 items-center justify-center lg:my-5 md:my-5 my-5 mb-10"
                    >
                        <motion.button
                            whileHover={{
                                scale: 1,
                                textShadow: "0px 0px 2px rgb(0,0,0)",
                                boxShadow: "0px 0px 6px rgb(0,0,0)",
                            }}
                            aria-label="Submit"
                            type="submit"
                            disabled={isLoading}
                            className={`bg-main border-none text-white uppercase rounded ${isLoading ? "" : "p-4"
                                } w-full`}
                        >
                            {isLoading ? <Loader /> : "Login"}
                        </motion.button>
                    </div>
                </form>
            </div>

        </div>
    )
}

export default Login